var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "search" },
    [
      _c(
        "ui-search",
        {
          directives: [
            {
              name: "focus",
              rawName: "v-focus",
              value: _vm.focus,
              expression: "focus"
            }
          ],
          staticClass: "input",
          class: { focus: _vm.focus },
          attrs: { disabled: _vm.converting },
          model: {
            value: _vm.input,
            callback: function($$v) {
              _vm.input = $$v
            },
            expression: "input"
          }
        },
        [
          _c("icon-close", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.input && !_vm.loading,
                expression: "input && !loading"
              }
            ],
            staticClass: "close cl-blue",
            on: {
              click: function($event) {
                return _vm.clear()
              },
              mousedown: function($event) {
                $event.preventDefault()
              }
            }
          }),
          _vm._v(" "),
          _c("ui-spinner", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.loading,
                expression: "loading"
              }
            ],
            staticClass: "cl-blue"
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.focus && _vm.suggestions.length,
              expression: "focus && suggestions.length"
            }
          ],
          staticClass: "dropdown"
        },
        _vm._l(_vm.suggestions, function(location) {
          return _c(
            "a",
            {
              key: location.place_id,
              staticClass: "option u-cut",
              on: {
                click: function($event) {
                  return _vm.select(location)
                },
                mousedown: function($event) {
                  $event.preventDefault()
                }
              }
            },
            [
              _c("span", { staticClass: "w5" }, [
                _vm._v(_vm._s(location.structured_formatting.main_text))
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "t12 cl-gray" }, [
                _vm._v(_vm._s(location.structured_formatting.secondary_text))
              ])
            ]
          )
        }),
        0
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }